import { App } from "vue";
import gtag from "vue-gtag-next";

export default function install(app: App) {
  if (import.meta.env.VITE_DEPLOY !== "master") return; // master 배포가 아닌 경우 제외

  app.use(gtag, {
    // GA4 태그로만 사용합니다.
    // UA는 GA4 태그 맵핑으로만 사용합니다.
    property: {
      id: "G-49CQP20MC8",
    },
  });
}

/**
 * 구글 태그매니저
 * 2022.07.18, 노건영 팀장님 / 임주영 매니저님 요청 건
 */
export const googleTagManager = () => {
  if (import.meta.env.VITE_DEPLOY !== "master") return; // master 배포가 아닌 경우 제외

  const TAG_ID = "TagManager";
  const isExist = document.getElementById(TAG_ID);
  if (isExist) return; // 이미 스크립트가 존재하는 경우 패스

  const headScript = document.createElement("script");
  headScript.id = TAG_ID;
  headScript.innerHTML = `
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-P5X7S2N');
  `;

  document.head.appendChild(headScript);
};
